import { $api } from "../generated/client";
import type { components } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

type ReturnWorkflowTriggerType =
	components["schemas"]["ReturnWorkflowWebhookEventDto"]["type"];
type WorkflowWebhookVersion = NonNullable<
	components["schemas"]["SendTestReturnWorkflowWebhookBodyDto"]["version"]
>;

/** Every "Send webhook" node of the shop's return workflows, with the health of its URL. */
export default function useReturnWorkflowWebhooks(shopId: string) {
	return $api.useQuery("get", "/shops/{shopId}/return-workflow-webhooks", {
		params: { path: { shopId } },
	});
}

/** The exact payload a return workflow with this trigger sends. */
export function useReturnWorkflowWebhookSample(
	shopId: string,
	triggerType: string | undefined,
	version?: WorkflowWebhookVersion,
) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/return-workflow-webhooks/sample",
		{
			params: {
				path: { shopId },
				query: {
					triggerType: triggerType as ReturnWorkflowTriggerType,
					version,
				},
			},
		},
		{ enabled: !!triggerType, staleTime: Infinity },
	);
}

export function useSendTestReturnWorkflowWebhook(shopId: string) {
	return useApiMutation<
		"post",
		"/shops/{shopId}/return-workflow-webhooks/test",
		{ url: string; triggerType: string; version?: WorkflowWebhookVersion }
	>("post", "/shops/{shopId}/return-workflow-webhooks/test", {
		notify: false,
		mapVariables: ({ url, triggerType, version }) => ({
			params: { path: { shopId } },
			body: {
				url,
				triggerType: triggerType as ReturnWorkflowTriggerType,
				version,
			},
		}),
	});
}
